/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BatchAutocompleteItemSchemaField } from './batchAutocompleteItemSchemaField';

export interface BatchAutocompleteItemSchema {
  field: BatchAutocompleteItemSchemaField;
  /** @maxLength 200 */
  prefix: string;
}
